import React from 'react';
import { useAuth } from './Auth/AuthProvider';
import { UserType } from './Types/User';
import BuilderView from './Builder/BuilderView';
import ParentDashboardView from './ParentDashboard/ParentDashboardView';

const LandingView: React.FC = () => {
  const { userType } = useAuth();

  switch (userType) {
    case UserType.Parent:
      return <ParentDashboardView />;
    case UserType.Student:
    default: // Unauthenticated
      return <BuilderView />;
  }
};

export default LandingView;
